export const ALL_CATEGORY_REQUEST = "ALL_CATEGORY_REQUEST";
export const ALL_CATEGORY_REQ_SUCCESS = "ALL_CATEGORY_REQ_SUCCESS";
export const ALL_CATEGORY_REQ_FAIL = "ALL_CATEGORY_REQ_FAIL";
export const ADD_NEW_CATEGORY_REQUEST = "ADD_NEW_CATEGORY_REQUEST";
